<template>
<div class="page-content original-dialog">
    <div class="cashier-report">
      <h1 class="page-title">
        {{ $locale("sideMenu.operations.cashierReport") }}
      </h1>

      <el-row class="search-area">
        <el-col
          :span="24"
          class="ta-l"
        >
          <el-button
            :class="shiftType ? 'egl-btn-white' : 'egl-btn-yellow'"
            @click="getData_fn({ current: false })"
          >
            {{ $locale("cashierReport.shiftClose") }}
          </el-button>
          <el-button
            :class="shiftType ? 'egl-btn-yellow' : 'egl-btn-white'"
            @click="getData_fn({ current: true })"
          >
            {{ $locale("cashierReport.shiftOpen") }}
          </el-button>
        </el-col>
      </el-row>

      <el-table
        :data="shiftReportTableData"
        class="egl-table list-table result-table"
        ref="filterTable"
        @sort-change="sort_fn"
        @filter-change="filter_fn"
      >

        <template v-for="th in shiftReportThead">
          <el-table-column
            :min-width="180"
            :label="th.label"
            :prop="th.prop"
            :key="th.prop"
            :sortable="th.sort"
            :align="th.align"
            :column-key="th.filters && th.prop"
            :filters="th.filters && shiftReportFilterList"
          ></el-table-column>
        </template>

        <el-table-column
          :label="$locale('global.control')"
          align="center"
        >
          <template slot-scope="scope">
            <div class="handle">
              <a v-if="scope.row.deviceType !== 'WEB' && scope.row.deviceType !== 'CMS'" @click="detail_fn(scope.row.id, 'edit')">{{ $locale("global.edit") }}</a>
              <el-divider v-if="scope.row.deviceType !== 'WEB' && scope.row.deviceType !== 'CMS'" direction="vertical"></el-divider>
              <a @click="detail_fn(scope.row.id, 'detail')">{{ $locale("global.detail") }}</a>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <CashierReportDetail
        :dialogVisible="dialogVisible"
        :shiftType="shiftType"
        :actualCashTitle="actualCashTitle"
        :shiftDetail="shiftDetail"
        @closeFn="closeDialog"
        :actionType="actionType"
      >
      </CashierReportDetail>
    </div>
  </div>
</template>

<script>
import {
  shiftReportThead,
  shiftReportDataMassage,
  shiftReportDetailDataMassage
} from "@/assets/js/cashierReport.js";
import CashierReportDetail from "@/components/CashierReport/CashierReportDetail.vue";
import { getDailyClosingShiftList, getShiftDetail } from "@/helpers/service/api/cashierReport.js";
import "@/assets/style/cashierReport.less";

export default {
  name: "CashierReport",
  data() {
    return {
      shiftType: false,
      dialogVisible: false,
      actualCashTitle: "",
      shiftDetail: {},
      shiftReportThead,
      originalData: [],
      originDetailData: {},
      shiftReportTableData: [],
      shiftReportFilterList: [],
      sort: "ASC",
      curId: "",
      actionType: '',
    };
  },
  methods: {
    clearFilter() {
      this.$refs.filterTable.clearFilter();
    },
    clearSort() {
      this.$refs.filterTable.clearSort();
    },
    openDialog() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.getData_fn()
    },
    getData_fn(data) {
      const that = this;
      const _data = {
        cinemaId: window.localStorage.cinemaId,
        current: that.shiftType,
        sort: "",
        typeName: "deviceType",
        typeNameValueList: [],
        ...data
      };

      const updateCurrent = this.shiftType !== _data.current;
      that.shiftType = _data.current;

      getDailyClosingShiftList(_data).then(res => {
        let { tableData } = shiftReportDataMassage(res.data, that.shiftType);
        tableData = tableData.filter(item => item.deviceType === "POS" || item.deviceType === "SELFCASHIER" || item.deviceType === "WEB" || item.deviceType === "CMS");
        // tableData = tableData.filter()
        if(that.shiftReportFilterList.length === 0 || updateCurrent) {
          that.shiftReportFilterList = [ ...new Set(tableData.map(item => item.deviceType)) ].map(e => ({ text: e, value: e }));
        }

        if(updateCurrent) {
          that.clearSort();
          that.clearFilter();
        }
        that.shiftReportTableData = tableData;
        that.originalData = res.data;
      });
    },
    detail_fn(id, type) {
      this.actionType = type
      getShiftDetail({ shiftId: id }).then(res => {
        if(res.data) {
          this.originDetailData = res.data
          let tableData = shiftReportDetailDataMassage(res.data, this.shiftType);
          if(tableData.deviceType !== "POS" && this.shiftType) {
            this.actualCashTitle = `${this.$locale("cashierReport.dialog.closingCashTypeTable")} (${this.$locale("cashierReport.dialog.currentTime")}${this.$moment().format("YYYY/MM/DD HH:mm:ss")})`;
          }else {
            this.actualCashTitle = this.$locale("cashierReport.dialog.closingCashTypeTable");
          }
          this.shiftDetail = tableData;
        } else {
          let tableData = {
            accountPayableInCashs: [],
            actualCash:[],
            basic: [
              {
                closeUserName: "-",
                deviceName: "-",
                deviceType: "-",
                operatingTime: "-"
              }
            ],
            cmsSalesInCashs: [],
            couponTypeInCashs: [],
            refundAccountPayableInCashs: [],
            refundCouponTypeInCashs: [],
            salesInCashs: []
          };
          this.actualCashTitle = `${this.$locale("cashierReport.dialog.closingCashTypeTable")} (${this.$locale("cashierReport.dialog.currentTime")}${this.$moment().format("YYYY/MM/DD HH:mm:ss")})`;
          this.shiftDetail = tableData;
        }
        this.curId = id;
        this.openDialog();
      });
    },
    sort_fn({ order }) {
      this.sort = order === "descending" ? "DESC" : "ASC";
      this.getData_fn({ sort: this.sort });
    },
    filter_fn(filters) {
      this.getData_fn({ typeNameValueList: filters.deviceType });
    },
  },
  mounted() {
    this.getData_fn();
  },
  components: {
    CashierReportDetail
  },
};
</script>
